exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.aftersale-edit-dialog .el-dialog{max-width:360px;min-width:336px\n}\n.aftersale-edit-dialog .el-dialog .el-dialog__footer{margin-top:-30px\n}\n", "", {"version":3,"sources":["/data/jenkins/workspace/shop/src/components/aftersale/aftersale-edit-dialog.vue"],"names":[],"mappings":";AAoEA,kCAEI,gBACA,eAAgB;CAHpB;AAAA,qDAKM,gBAAiB;CAClB","file":"aftersale-edit-dialog.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.aftersale-edit-dialog {\n  .el-dialog {\n    max-width: 360px;\n    min-width: 336px;\n    .el-dialog__footer {\n      margin-top: -30px;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c885d316","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/aftersale/aftersale-edit-dialog.vue
// module id = KgTU
// module chunks = 2